import { IconProps, iconA11yProps } from '../types';

export const Replay = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <path d="M3.0498 3V8H8.0498" />
        <path d="M3.99976 7.87292C5.49599 4.97856 8.51683 3.00012 11.9998 3.00012C16.9703 3.00012 20.9998 7.02956 20.9998 12.0001C20.9998 16.9707 16.9703 21.0001 11.9998 21.0001C7.3672 21.0001 3.55213 17.5001 3.05469 13.0001" />
        <path d="M11 14.5L15.1667 12L11 9.5V14.5Z" />
    </svg>
);
